export default "__VITE_ASSET__CgfAN5XF__"